import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutlinedDismissIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M14.1569 2.84315C17.281 5.96734 17.281 11.0327 14.1569 14.1569C11.0327 17.281 5.96734 17.281 2.84315 14.1569C-0.281049 11.0327 -0.281049 5.96734 2.84315 2.84315C5.96734 -0.281049 11.0327 -0.281049 14.1569 2.84315Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.23726 10.7627L10.7627 6.23726M6.23726 6.23726L10.7627 10.7627M14.1569 2.84315C17.281 5.96734 17.281 11.0327 14.1569 14.1569C11.0327 17.281 5.96734 17.281 2.84315 14.1569C-0.281049 11.0327 -0.281049 5.96734 2.84315 2.84315C5.96734 -0.281049 11.0327 -0.281049 14.1569 2.84315Z",
			stroke: "#007AAF",
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgOutlinedDismissIcon);
const Memo = memo(ForwardRef);
export default Memo;
